import { Stack, Typography } from "@mui/material";
import { CoreButton } from "@verity/components/core";
import { useNavigate } from "react-router-dom";
import i18n from "../../../../../i18n";
import { computer } from "../assets";
import styles from "./InterviewResultsEmptyPage.module.css";

export default function InterviewResultsEmptyPage() {
	const navigate = useNavigate();
	return (
		<div className={styles.wrapper}>
			<img src={computer} />
			<Typography className={styles.title}>{i18n.t("candidate.resultsPage.empty.title")}</Typography>
			<Typography className={styles.description}>{i18n.t("candidate.resultsPage.empty.description")}</Typography>
			<Stack direction="row" gap="20px">
				<CoreButton color="secondary" onClick={() => navigate("/interviews")}>
					{i18n.t("candidate.resultsPage.empty.button.dashboard")}
				</CoreButton>
				<CoreButton onClick={() => navigate("/interviews/schedule")}>
					{i18n.t("candidate.resultsPage.empty.button.schedule")}
				</CoreButton>
			</Stack>
		</div>
	);
}
